module.exports = __webpack_public_path__ + "img/1200px-Hibernian_FC_logo.svg.7ee4bb60.png";